module.exports = __webpack_public_path__ + "img/1F97A.131f4451.svg";